import Box from "./Box";
import BoxWithGutter from "./BoxWithGutter";
import IndentedParagraphSmall from "./IndentedParagraphSmall";
import NewsletterSignup from "./NewsletterSignup";
import React from "react";
import Text from "./Text";

function LatestDropSignup({ brand }) {
  return (
    <BoxWithGutter maxWidth={1000} mx="auto">
      <div className="dashed-border-box">
        <Box
          display="flex"
          justifyContent="center"
          flexDirection="column"
          alignItems="center"
          py={[40, null, 64, null]}
          px={[20, null, 64, null]}
        >
          <Text
            as="h4"
            uppercase
            fontSize={[22, 22, 62, 62]}
            lineHeight={1}
            textAlign="center"
          >
            This drop's been a sell out!
          </Text>
          <Box
            maxWidth={610}
            mx="auto"
            display="flex"
            flexDirection="column"
            alignItems="center"
          >
            <Box mt={[38, null, 70, null]} mb={[38, null, 50, null]}>
              <IndentedParagraphSmall>
                Sign up to Reskinned to find out more about what we do and be
                the first to find out when drops are happening from the brands
                you love.
              </IndentedParagraphSmall>
            </Box>
            <NewsletterSignup brand={brand} />
          </Box>
        </Box>
      </div>
    </BoxWithGutter>
  );
}

export default LatestDropSignup;
